import React from "react";
import { Badge } from "./Badge";
import type { ProgressStatus } from "../data/progressData";
type StatusBadgeProps = {
  status: ProgressStatus;
  compact?: boolean;
};
const tones: Record<ProgressStatus, string> = {
  "On Track": "border-[#bae4c8] bg-[#eaf8ee] text-[#17733b]",
  "Needs Support": "border-[#f0d58b] bg-[#fff8df] text-[#86630b]",
  Behind: "border-[#f0c39d] bg-[#fff0e3] text-[#a34d05]",
  Inactive: "border-[#f2b5b7] bg-[#fff0f0] text-[#a93132]",
  Pending: "border-[#f2db8e] bg-[#fff8d8] text-[#765a00]"
};
export function StatusBadge({
  status,
  compact = false
}: StatusBadgeProps) {
  return <Badge variant="outline" className={`whitespace-nowrap border font-semibold ${compact ? "px-1.5 py-0 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${tones[status]}`} data-id="element-332" data-mp="2rrhwpjs3mgfs">{status}</Badge>;
}